import { Popover as BasePopover } from '@base-ui/react/popover';
import { FC } from 'react';

import CloseIcon from '@/assets/svg/ui-elements/close.svg';

import { IconButton } from '../Button';
import Typography from '../Typography';
import { PopupContent, StyledPopup, StyledPositioner, TitleRow } from './Popover.styled';
import { PopoverProps } from './types';

const Popover: FC<PopoverProps> = ({
  open,
  onOpenChange,
  anchor,

  children,
  side = 'top',
  align = 'center',

  title,
  showClose = false,
  maxWidth,
  maxHeight = 320,
}) => {
  const closeButton = showClose && (
    <BasePopover.Close
      render={
        <IconButton type="button" color="tertiary" variant="ghost" size="xs" aria-label="Close">
          <CloseIcon />
        </IconButton>
      }
    />
  );

  return (
    <BasePopover.Root open={open} onOpenChange={onOpenChange}>
      <BasePopover.Portal>
        <StyledPositioner anchor={anchor} side={side} align={align} sideOffset={8}>
          <StyledPopup $maxWidth={maxWidth} $maxHeight={maxHeight}>
            {(title || closeButton) && (
              <TitleRow>
                {title && (
                  <Typography variant="h6" as="h2" style={{ flex: 1 }}>
                    {title}
                  </Typography>
                )}
                {closeButton}
              </TitleRow>
            )}

            <PopupContent>{children}</PopupContent>
          </StyledPopup>
        </StyledPositioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
};

export default Popover;

Popover.displayName = 'Popover';
